<template>
  <div class="">
    <div class="ps-mover-actions">
      <button type="button" @click="mover()" class="btn btn-danger rounded-pill">move</button>
      <button type="button" @click="copyTemplate()" class="btn btn-outline-light rounded-pill">copy</button>
    </div>
    <div ref="component">
      <slot name="components"></slot>
    </div>
  </div>
</template>


<script>
import {generateRandomString} from "@/store/Modules/Site";

export default {
  name: "Mover",
  props: {
    component: {
      required: true
    },
    folder: {
      required: true
    },
    componentName: {
      required: true
    },
    componentSlots: {
      required: true
    },
    componentType: {
      required: true
    }
  },
  methods: {
    generateRandomString,
    buildComponent() {
      const baseComponent = {
        id: generateRandomString(),
        name: this.component,
        slots: {},
        props: {},
        css: '',
        class: '',
        componentType: this.componentType,
        detail: {
          tag: {
            folder: this.folder,
            name: this.componentName
          }
        }
      }

      this.componentSlots.forEach(slot => {
        baseComponent["slots"][slot] = {
          text: slot,
          components: []
        }
      })

      return baseComponent
    },
    mover() {
      this.$store.dispatch('Site/addComponent', this.buildComponent())
    },
    copyTemplate() {
      this.$store.dispatch('Site/copyComponentJson', this.buildComponent())
    },
  }
}
</script>

<style scoped>
.ps-mover-actions {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 6px;
}
</style>